export default __webpack_public_path__ + "static/media/icons8-upload-document.394e0b65.svg";